/*
 * AAIKO product-card image gallery.
 *
 * CLIENT REQUEST (feedback 28/08/2026): "POP - pijltjes voor doorswipe door
 * beelden toevoegen, zoals COS. Dit is in ons design opgemaakt maar staat niet
 * meer in de laatste designs." It is in no Figma frame, so it is built to the
 * reference AAIKO named: on a pointer, two chevrons appear over the photograph
 * and step through the product's images; on touch, a horizontal swipe does the
 * same and there are no chevrons.
 *
 * All this file does is move `data-gal` on the card frame. Which photograph
 * that shows is CSS (snippets/aaiko-product-card.liquid), so a card with this
 * script blocked or still loading is exactly the card that shipped before:
 * first image, hover swap, nothing else. The arrows only exist in the markup
 * when a caller asked for the gallery AND there is more than one photograph, so
 * there is never a control here that cannot do anything.
 *
 * Delegated from the document rather than instantiated per card: a collection
 * page renders twenty-odd of these and load-more appends more without telling
 * anyone. One listener set covers every card that exists and every card that
 * ever will.
 */
(function () {
  'use strict';

  if (window.__aaikoCardGallery) return;
  window.__aaikoCardGallery = true;

  /* Past this, a horizontal drag is a swipe and not a tap that wandered. 40px
     is Safari's own scroll-vs-tap neighbourhood; below it a shopper aiming at
     the card would page the gallery by accident. */
  var SWIPE = 40;
  /* And a swipe has to be more horizontal than vertical, or every scroll that
     starts on a photograph pages the images under the thumb. */
  var SLOPE = 1.2;

  /** @param {Element} frame @param {number} step */
  function move(frame, step) {
    var count = parseInt(frame.getAttribute('data-gal-count') || '0', 10);
    if (!(count > 1)) return;
    var current = parseInt(frame.getAttribute('data-gal') || '0', 10);
    if (!(current >= 0)) current = 0;
    /* Wraps in both directions: the last image's "next" is the first, which is
       what a two-image card needs most - otherwise half the cards on the page
       have one dead arrow. */
    var next = (current + step + count) % count;
    frame.setAttribute('data-gal', String(next));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-aaiko-cardgal-step]');
    if (!button) return;
    var frame = button.closest('[data-aaiko-cardgal]');
    if (!frame) return;
    /* The arrows sit over the media link's box. Stop here or the click reaches
       the card and navigates away from the image just asked for. */
    event.preventDefault();
    event.stopPropagation();
    move(frame, parseInt(button.getAttribute('data-aaiko-cardgal-step'), 10) || 1);
  });

  /* ---- touch ----
     pointerdown/up on the frame, not a touch library: the card is a link, so
     the only thing to get right is telling a swipe apart from a tap and
     stopping the link when it was a swipe. `pointerType` gates it to touch and
     pen, because on a mouse the arrows are already there and a drag over a
     photograph is a text/image selection, not a gesture. */
  var start = null;

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.pointerType === 'mouse') return;
      var frame = event.target.closest && event.target.closest('[data-aaiko-cardgal]');
      if (!frame) return;
      start = { frame: frame, x: event.clientX, y: event.clientY, swiped: false };
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      if (!start) return;
      var dx = event.clientX - start.x;
      var dy = event.clientY - start.y;
      var frame = start.frame;
      var far = Math.abs(dx) >= SWIPE && Math.abs(dx) > Math.abs(dy) * SLOPE;
      start = null;
      if (!far) return;
      /* Left drags forward, the direction the photographs travel. */
      move(frame, dx < 0 ? 1 : -1);
      /* The link fires on the click that follows this pointerup, so the flag
         is read there. Set on the frame rather than kept in this closure
         because the click can arrive after another pointerdown on iOS. */
      frame.setAttribute('data-gal-swiping', '');
    },
    { passive: true }
  );

  document.addEventListener(
    'pointercancel',
    function () {
      start = null;
    },
    { passive: true }
  );

  /* Capture phase: the media link is the deepest target, so the swipe flag has
     to be read before the anchor's own default runs. */
  document.addEventListener(
    'click',
    function (event) {
      var frame = event.target.closest && event.target.closest('[data-gal-swiping]');
      if (!frame) return;
      frame.removeAttribute('data-gal-swiping');
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})();
